/* =========================================
   VOLVIAX - CART DRAWER UPSELL
   Travel Cup Color Selector
   ========================================= */

(() => {
  if (window.volviaxCartUpsellInitialized) return;
  window.volviaxCartUpsellInitialized = true;

  // Update the product image when a color is selected.
  document.addEventListener('change', (event) => {
    const select = event.target.closest(
      '.volviax-cart-upsell__variant-select'
    );

    if (!select) return;

    const upsell = select.closest('.volviax-cart-upsell');
    const button = upsell?.querySelector(
      '.volviax-cart-upsell__button'
    );

    const selectedOption = select.selectedOptions[0];

    if (!button || !selectedOption) return;

    button.dataset.volviaxCupId = select.value;

    const image = upsell.querySelector(
      '.volviax-cart-upsell__content img'
    );

    const imageUrl = selectedOption.dataset.image;

    if (image && imageUrl) {
      image.src = imageUrl;
    }
  });

  // Add the selected Travel Cup to the cart.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest(
      '.volviax-cart-upsell__button'
    );

    if (!button || button.disabled) return;

    event.preventDefault();

    const upsell = button.closest('.volviax-cart-upsell');

    const select = upsell?.querySelector(
      '.volviax-cart-upsell__variant-select'
    );

    const variantId = Number(
      select?.value || button.dataset.volviaxCupId
    );

    if (!variantId) {
      console.error('Volviax: Travel Cup variant ID missing.');
      return;
    }

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const cartResponse = await fetch(
        root + 'cart.js',
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!cartResponse.ok) {
        throw new Error('Unable to check cart.');
      }

      const currentCart = await cartResponse.json();

      // Prevent adding another cup when one is already present.
      const cupProductId = Number(
        upsell?.dataset.volviaxCupProductId
      );

      const cupAlreadyAdded = currentCart.items.some(
        (item) =>
          (cupProductId && item.product_id === cupProductId) ||
          item.variant_id === variantId
      );

      if (cupAlreadyAdded) {
        throw new Error('Travel Cup is already in your cart.');
      }

      const addResponse = await fetch(
        root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ],
            sections: [
              'cart-drawer',
              'cart-icon-bubble'
            ],
            sections_url: window.location.pathname
          })
        }
      );

      const result = await addResponse.json();

      if (!addResponse.ok || result.status) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add Travel Cup.'
        );
      }

      const cartDrawer = document.querySelector('cart-drawer');

      if (
        cartDrawer &&
        result.sections?.['cart-drawer']
      ) {
        const updatedDocument = new DOMParser().parseFromString(
          result.sections['cart-drawer'],
          'text/html'
        );

        const updatedDrawer = updatedDocument.querySelector(
          '#CartDrawer'
        );

        const currentDrawer = cartDrawer.querySelector(
          '#CartDrawer'
        );

        if (updatedDrawer && currentDrawer) {
          currentDrawer.innerHTML = updatedDrawer.innerHTML;

          cartDrawer.classList.remove('is-empty');

          const overlay = cartDrawer.querySelector(
            '#CartDrawer-Overlay'
          );

          if (overlay) {
            overlay.addEventListener(
              'click',
              cartDrawer.close.bind(cartDrawer)
            );
          }
        }
      }

      if (result.sections?.['cart-icon-bubble']) {
        const iconContainer = document.getElementById(
          'shopify-section-cart-icon-bubble'
        );

        if (iconContainer) {
          const updatedDocument = new DOMParser().parseFromString(
            result.sections['cart-icon-bubble'],
            'text/html'
          );

          const updatedIcon = updatedDocument.querySelector(
            '.shopify-section'
          );

          if (updatedIcon) {
            iconContainer.innerHTML = updatedIcon.innerHTML;
          }
        }
      }

    } catch (error) {
      console.error('Volviax Cart Upsell:', error);

      button.disabled = false;
      button.textContent = originalText;

      alert(
        error.message ||
        'Something went wrong. Please try again.'
      );
    }
  });
})();